import { useNavigate } from 'react-router-dom';
import { setSelectedForm } from 'features/form/formReducer';
import { useFormClearer } from 'hooks/useFormCleaner';
import { useAppSelector } from 'hooks/useAppSelector';
import { useAppDispatch } from 'hooks/useAppDispatch';
import { AgxButton, useDialog } from '@urbanx/agx.ui-components2';
import { FormType } from '@urbanx/agx.campaigns.client';
import type { FormDetails } from '@urbanx/agx-ui-components';
import { CampaignEntryDialog } from './CampaignEntryDialog';

interface NewFormButtonProps {
  id?: string;
}

export const NewFormButton = ({ id = 'agx-btn-newform6' }: NewFormButtonProps) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const clearFormData = useFormClearer();
  const { availableForms } = useAppSelector((state) => state.forms);
  const {
    info: { agencyStates },
  } = useAppSelector((state) => state.agencies.agencyInfo);
  const stateDialog = useDialog(CampaignEntryDialog);
  const agreementForms = availableForms.filter(
    (form) =>
      form.type === FormType.ListingGenerator &&
      form.beginsCampaign &&
      agencyStates?.some((state: string | null) => state === form.state)
  );
  const states = [...new Set(agreementForms.map((form) => form.state))];

  const selectState = (state: FormDetails['state']) => {
    const form = agreementForms.find((form) => form.state === state);
    if (!form) throw new Error(`No listing agreement is available for ${state}.`);
    clearFormData();
    dispatch(
      setSelectedForm({
        formType: form.type,
        state: form.state,
        formConfigType: form.formConfigType,
      })
    );
    navigate('/form');
  };

  return (
    <AgxButton
      text="New Agreement"
      onClick={() => {
        if (states.length === 1) {
          selectState(states[0]);
          return;
        }
        stateDialog.open({ id, states, onSelect: selectState });
      }}
      variant="primary"
      size="large"
      dataTestId={id}
      id={id}
    />
  );
};
